/* unplugin-vue-components disabled */import __unplugin_components_0 from '/var/repos/bic-vue/src/components/common/SvgIcon.vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "configuration-saved-card text-white"
};
const _hoisted_2 = {
  class: "flex flex-col px-4 pb-2 relative z-50 overflow-hidden bg-primaryDark rounded-lg rounded-b-[4px] shadow-lg"
};
const _hoisted_3 = {
  class: "flex h-[155px] w-[225px] overflow-hidden bg-slate-400"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-2"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "opacity-45 font-light"
}, "Design"), /*#__PURE__*/_createElementVNode("p", {
  class: "opacity-85 font-light"
}, "Your design is saved")], -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute -bottom-2 left-0 right-0 bg-[#8865f6] h-12 rounded-lg z-10"
}, null, -1);
import { useConfigurationStore } from "@/stores/configurationModule";
export default {
  __name: 'ConfigurationSavedCard',
  setup(__props) {
    const $eventBus = inject('bus');
    const configurationStore = useConfigurationStore();
    const {
      configurationScreenshotData
    } = storeToRefs(configurationStore);
    // border-b-8 border-[#8865f6]

    return (_ctx, _cache) => {
      const _component_SvgIcon = __unplugin_components_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = $event => _unref($eventBus).$emit('close-configuration-saved-card')),
        class: "self-end py-3 px-2 opacity-65"
      }, [_createVNode(_component_SvgIcon, {
        class: "w-5 h-5 -mr-2",
        fill: "white",
        svgSymbolId: "close"
      })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: _unref(configurationScreenshotData),
        class: "w-full h-auto -mt-4 object-cover"
      }, null, 8, _hoisted_4)]), _hoisted_5]), _hoisted_6]);
    };
  }
};